import type * as React from 'react';

import { cn } from '@/lib/utils';

// Shared by Input, Textarea and the Select trigger so every control reads the same.
const controlClasses =
  'w-full min-w-0 rounded-control border border-line-control bg-surface text-fg outline-none transition-[border-color,box-shadow] placeholder:text-fg-muted focus-visible:border-label focus-visible:ring-[3px] focus-visible:ring-label/25 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-err aria-invalid:ring-[3px] aria-invalid:ring-err/20';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        controlClasses,
        'h-9 px-3 py-1 text-base selection:bg-label selection:text-white file:inline-flex file:h-7 file:border-0 file:bg-transparent file:font-medium file:text-fg file:text-sm md:text-sm',
        className
      )}
      {...props}
    />
  );
}

export { Input, controlClasses };
